<template>
  <div>
    <div class="row">
      <div class="col form__col">
        <label>{{ $t('businessContractWorkDone') }}</label>

        <!-- Tout -->
        <checkbox-gcr
          data-test-id="scope-of-work-all"
          :label="$t('workdoneAll')"
          :checked="allChecked"
          :indeterminate="someChecked && !allChecked"
          @change="toggleAll"
          :show-validation-feedback="false"
          :validation-feedback="scopeOfWorkValidationFeedback"
        />

        <hr class="my-2" />

        <!-- 1. Fondation -->
        <checkbox-gcr
          data-test-id="scope-of-work-foundations"
          :label="$t('workdoneFoundation')"
          v-model="scopeOfWork.foundations"
          :show-validation-feedback="false"
          :validation-feedback="scopeOfWorkValidationFeedback"
        />

        <!-- 2. Charpente isolée et étanchéisée -->
        <checkbox-gcr
          data-test-id="scope-of-work-frame"
          :label="$t('workdoneFrame')"
          :checked="isFrameAllChecked"
          :indeterminate="isFrameSomeChecked && !isFrameAllChecked"
          @change="toggleCategory('frame', $event)"
          :show-validation-feedback="false"
          :validation-feedback="scopeOfWorkValidationFeedback"
        />
        <div class="subcategories">
          <checkbox-gcr
            data-test-id="scope-of-work-frame-structure"
            :label="$t('workdoneFrameStructure')"
            v-model="scopeOfWork.frameStructure"
            :show-validation-feedback="false"
          />
          <checkbox-gcr
            data-test-id="scope-of-work-frame-roofing"
            :label="$t('workdoneFrameRoofing')"
            v-model="scopeOfWork.frameRoofing"
            :show-validation-feedback="false"
          />
          <checkbox-gcr
            data-test-id="scope-of-work-frame-windows"
            :label="$t('workdoneFrameWindows')"
            v-model="scopeOfWork.frameWindows"
            :show-validation-feedback="false"
          />
          <checkbox-gcr
            data-test-id="scope-of-work-frame-insulation"
            :label="$t('workdoneFrameInsulation')"
            v-model="scopeOfWork.frameInsulation"
            :show-validation-feedback="false"
          />
        </div>

        <!-- 3. HVAC -->
        <checkbox-gcr
          data-test-id="scope-of-work-hvac"
          :label="$t('workdoneHvac')"
          :checked="isHvacAllChecked"
          :indeterminate="isHvacSomeChecked && !isHvacAllChecked"
          @change="toggleCategory('hvac', $event)"
          :show-validation-feedback="false"
          :validation-feedback="scopeOfWorkValidationFeedback"
        />
        <div class="subcategories">
          <checkbox-gcr
            data-test-id="scope-of-work-hvac-electrical"
            :label="$t('workdoneHvacElectrical')"
            v-model="scopeOfWork.hvacElectrical"
            :show-validation-feedback="false"
          />
          <checkbox-gcr
            data-test-id="scope-of-work-hvac-plumbing"
            :label="$t('workdoneHvacPlumbing')"
            v-model="scopeOfWork.hvacPlumbing"
            :show-validation-feedback="false"
          />
          <checkbox-gcr
            data-test-id="scope-of-work-hvac-ventilation"
            :label="$t('workdoneHvacVentilation')"
            v-model="scopeOfWork.hvacVentilation"
            :show-validation-feedback="false"
          />
        </div>

        <!-- 4. Gypse -->
        <checkbox-gcr
          data-test-id="scope-of-work-drywall"
          :label="$t('workdoneDrywall')"
          v-model="scopeOfWork.drywall"
          :show-validation-feedback="false"
          :validation-feedback="scopeOfWorkValidationFeedback"
        />

        <!-- 5. Finition intérieure -->
        <checkbox-gcr
          data-test-id="scope-of-work-interior-finishing"
          :label="$t('workdoneInteriorFinishing')"
          v-model="scopeOfWork.interiorFinishing"
          :show-validation-feedback="false"
          :validation-feedback="scopeOfWorkValidationFeedback"
        />

        <!-- 6. Revêtement extérieur -->
        <checkbox-gcr
          data-test-id="scope-of-work-exterior-covering"
          :label="$t('workdoneExteriorCovering')"
          v-model="scopeOfWork.exteriorCovering"
          :show-validation-feedback="false"
          :validation-feedback="scopeOfWorkValidationFeedback"
        />
      </div>
    </div>
    <div class="row col invalid-feedback" data-test-id="scope-of-work-validation-feedback">
      {{ scopeOfWorkValidationFeedback }}
    </div>
  </div>
</template>

<script>
import CheckboxGcr from '@/components/atoms/CheckboxNew'
import Validators from '@/_helpers/validators'

const FRAME_KEYS = ['frameStructure', 'frameRoofing', 'frameWindows', 'frameInsulation']
const HVAC_KEYS  = ['hvacElectrical', 'hvacPlumbing', 'hvacVentilation']
const ALL_KEYS   = ['foundations', ...FRAME_KEYS, ...HVAC_KEYS, 'drywall', 'interiorFinishing', 'exteriorCovering']

export default {
  components: { CheckboxGcr },
  props: {
    scopeOfWork: Object
  },
  computed: {
    isFrameAllChecked() {
      return FRAME_KEYS.every(k => this.scopeOfWork[k])
    },
    isFrameSomeChecked() {
      return FRAME_KEYS.some(k => this.scopeOfWork[k])
    },
    isHvacAllChecked() {
      return HVAC_KEYS.every(k => this.scopeOfWork[k])
    },
    isHvacSomeChecked() {
      return HVAC_KEYS.some(k => this.scopeOfWork[k])
    },
    allChecked() {
      return ALL_KEYS.every(k => this.scopeOfWork[k])
    },
    someChecked() {
      return ALL_KEYS.some(k => this.scopeOfWork[k])
    },
    scopeOfWorkValidationFeedback() {
      return Validators.test(this.someChecked, this.$t('scopeOfWorkRequired'))
    }
  },
  methods: {
    toggleCategory(category, checked) {
      const keys = category === 'frame' ? FRAME_KEYS : HVAC_KEYS
      keys.forEach(k => { this.scopeOfWork[k] = checked })
    },
    toggleAll(checked) {
      ALL_KEYS.forEach(k => { this.scopeOfWork[k] = checked })
    }
  }
}
</script>

<style scoped>
.subcategories {
  padding-left: 1.5rem;
  border-left: 2px solid #e0e0e0;
  margin-bottom: 0.5rem;
}
</style>